import SavingsPolicyOptions from "../../moneyBuilder/savings/datasets/savings_policy_options";
import calculateTotalSavings from "../../moneyBuilder/savings/objects/calculate_total_savings";

export const calculateShortTermSavings = (savingsInfo) => {
    let totalShortTermSavingsAmt = 0;
    const savingTotals = calculateTotalSavings(savingsInfo.savingsArr, "", "bank");
    const arrayLength = savingTotals.totalSavingsArr.length;
    for (let i=0; i<arrayLength; i++){
        const savingTotalsByType = savingTotals.totalSavingsArr[i];
        const savingsType = savingTotalsByType.savingsType;
        const longShortTerm = SavingsPolicyOptions.find(elem => elem.type === savingsType).term;
        if (longShortTerm === "short"){
            totalShortTermSavingsAmt += +savingTotalsByType.totalSavings;
        }
    }
    
    return totalShortTermSavingsAmt;
}
export default calculateShortTermSavings;